import RecoverStep from "./recover_step";
import {attachSelectableHandler} from "../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'virtualization-locate';

export default class LocateVirtualization extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        data.recovery.virtualization = { location: null, type: null, isTest: null, isLocal: null, format: null };
        data.render = { readyToRender : false };
        data.tmp.previousStep = fr.currentStep;

        // in case when we're moving backward
        if (!data.device_id) {
            data.devices = null;
            data.recovery.device_id = null;
            data.recovery.device_name = null;
        }
        if (data.virtualizationLocation && data.renderedFlowType === data.type) {
            data.render.readyToRender = true;
        } else {
            data.renderedFlowType = data.type;
            $.ajax({
                type:"GET",
                url: this.buildVirtLocationUrl(data),
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json",
                success: function(response) {
                    const loc_data = response.data;
                    data.virtualizationLocation = {
                        cloud : (loc_data['cloud_vm'] > 0),
                        local : (loc_data['local_vm'] > 0),
                        vmdk  : (loc_data['vmdk_export'] > 0),
                        vhd   : (loc_data['vhd_export'] > 0),
                        vhdx  : (loc_data['vhdx_export'] > 0),
                        dynamic : (loc_data['support_dynamic'] > 0)
                    };

                    data.render.readyToRender = true;
                    fr.render('locateVirtualization');
                }
            }).fail(fr.defaultAJAXErrorHandler);
        }
    }

    buildVirtLocationUrl(data) {
        let url = `/api/recover_flow/virtualization_locations/${data.clientId}`;
        url += "/" + (data.applianceId ?? 0);
        if (data.deviceId) {
            url += "/" + data.deviceId;
        }
        return url;
    }

    postRender(data, el, fr) {
        attachSelectableHandler(el, (d) => {
            data.recovery.virtualization.location = d.type;
            data.recovery.virtualization.isLocal = +(d.type === 'appliance');
        });
    }

}
